import React, { useState } from "react";
import "./ClaimConversationAction.css";

/**
 * ClaimConversationAction
 * Button an agent uses to take ownership of an unassigned conversation.
 * Shows a brief "claiming..." loading state, then a claimed state.
 *
 * Props:
 *  - conversationId
 *  - claimed: boolean (already claimed by current agent)
 *  - onClaim(conversationId): Promise|void
 */
export default function ClaimConversationAction({
  conversationId,
  claimed = false,
  onClaim = () => {},
}) {
  const [loading, setLoading] = useState(false);
  const [isClaimed, setIsClaimed] = useState(claimed);

  const handleClick = async () => {
    if (isClaimed || loading) return;
    setLoading(true);
    try {
      await Promise.resolve(onClaim(conversationId));
      setIsClaimed(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className={`cb-claim-btn ${isClaimed ? "claimed" : ""}`}
      onClick={handleClick}
      disabled={loading || isClaimed}
    >
      {loading && <span className="cb-claim-spinner" />}
      {isClaimed ? "Claimed ✓" : loading ? "Claiming…" : "Claim Conversation"}
    </button>
  );
}
